import React, { Component } from "react";
import {
  Tabs,
  WhiteSpace,
  List,
  Button,
  Modal,
  Checkbox,
  InputItem,
  Picker,
  Toast,
} from "antd-mobile-v2";
import "./index.less";
import Cancelation from "../Cancellation";
import { titleData } from "./const";
import sectioValue from "../../api/service/secsstion";
import tool from '../../api/tool';
const Item = List.Item;
const alert = Modal.alert;
export default class PerCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }
  componentDidMount() {}
  // 个人中心修改相关信息
  editUserInfo = (item) => {
    if (item.type == "editCoal") {
      alert('退出登录', '您确定退出吗', [
        { text: '取消', onPress: () => console.log('cancel') },
        {
          text: '确定',
          onPress: () =>{
            sectioValue.remove("token");
            sectioValue.remove("acount");
            sectioValue.remove("user_id");
            sectioValue.remove("nick_name");
            sectioValue.remove("refstoken");
            sectioValue.remove("tokenTime");
            this.props.history.push("/")
            tool.remove("userInfoData");
          }
           
        },
      ])
      return;
    }
    this.props.history.push({
      pathname: item.push,
      query: {
        type: item.type == "editUser" ? "editUser" : "",
      },
    });
  };
  setModal = (flag) => {
    this.setState({
      modal: flag,
    });
  };
  render() {
    const { ExpertRole, UserPic } = this.state;
    console.log(this.state.sub);
    return (
      <div className="percenter-wrapper">
        <Modal
          visible={this.state.modal}
          transparent
          title="确认注销"
          wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          <Cancelation setModal={this.setModal} props={this.props}/>
        </Modal>
        <List className="my-list">
          {titleData.map((item, index) => {
            return (
              <Item
                arrow="horizontal"
                onClick={() => {
                  this.editUserInfo(item);
                }}
                key={index}
              >
                {item.name}
              </Item>
            );
          })}
        </List>
        <div
          className="cancellation"
          onClick={() => {
            this.setState({
              modal: true,
            });
          }}
        >
          注销账号？
        </div>
      </div>
    );
  }
}
